import { css } from '@emotion/react';

export const adminShellCSS = () => css`
    height: 100vh;
    overflow: hidden; /* el scroll vive dentro de .admin-shell-main, no en la ventana */
    display: flex;
    flex-direction: column;
    background: #fff;
    font-family: var(--pei-font);
    color: var(--pei-text);

    .admin-shell-body {
        display: flex;
        flex: 1;
        min-height: 0;
    }

    .admin-shell-main {
        flex: 1;
        min-width: 0;
        padding: 28px 36px;
        overflow-y: auto;
        background: #fff;
    }
`;
